// eslint-disable-next-line import/no-extraneous-dependencies
import { Route, Routes } from 'react-router-dom';
import Landing from './landing';
import DocViewer from './doc-viewer';
import UpdatedDocViewer from './new-doc-viewer';
import MailRedirect from './mailRedirect';

export const Router = () => (
	<Routes>
		<Route path="/" element={<Landing />} />
		<Route
			path="/privacy-policy"
			element={<DocViewer src="pdf/privacy-policy.html" />}
		/>
		<Route
			path="/terms-of-use"
			element={<DocViewer src="pdf/terms-of-use.html" />}
		/>
		<Route
			path="/subscription-terms"
			element={<UpdatedDocViewer src="pdf/subscription-terms.html" />}
		/>
		<Route path="/support" element={<MailRedirect />} />
	</Routes>
);
